import styled from 'styled-components'
import { Styles as BaseStyles } from '~/pages/anatomy/libs/multipleChoiceStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  ...BaseStyles,

  Value: styled.p`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK};
  `,

  OptionIcon: styled.span`
    font-size: 22px;
    line-height: 1;
  `,

  ValueText: styled.span`
    font-weight: 700;
  `,
} as const
